import { color } from "@/styles/tokens";
import type { _SVGIcon } from "hsl-core/Components";

export const FILL = color.border.highlight;

const body: _SVGIcon.IconBody = (params) => {
	const fill = params?.fill ?? FILL;
	return `
    <g clip-path="url(#clip0_17499_167177)">
      <path d="M7.554 0.5L0.75 7.048V15.5H14.5V7.047L7.554 0.5ZM2 7.798L7.576 2.608L13.25 7.822V14.249H2V7.797V7.798Z" fill="${fill}"/>
    </g>
    <defs>
      <clipPath id="clip0_17499_167177">
        <rect width="15" height="15" fill="white" transform="translate(0 0.5)"/>
      </clipPath>
    </defs>
  `;
};

export default {
	W: 15,
	H: 16,
	body,
} as _SVGIcon.Icon;
